import React, {useEffect, useState} from 'react';
import {TestRunJson} from "../../api/json/TestRunJson"
import ApiError from "../../api/ApiError"
import {ProjectJson} from "../../api/json/ProjectJson"
import {AnyCustomModelJson} from "../../api/json/CustomModelJson"
import {PagedResponseJson} from "../../api/json/PagedResponseJson"
import {Box, CircularProgress} from "@mui/material"
import ErrorMessage from "../error/ErrorMessage"
import {TestRunRequests} from "../../api/requests/TestRunRequests"
import TestRunCard from "./TestRunCard"

interface TestRunScoringPanelProps {
    model: AnyCustomModelJson
    reloadQualityCheckStats: () => void
}

function TestRunScoringPanel({model, reloadQualityCheckStats}: TestRunScoringPanelProps) {
    const [page, setPage] = useState<PagedResponseJson<TestRunJson>>()
    const [error, setError] = useState<ApiError>()

    useEffect(() => {
        loadPage()
    }, [])

    const loadPage = () => {
        TestRunRequests.list(model.qualityCheck.id, 0, true)
            .then(response => setPage(response))
            .catch(setError)
    }

    if (!page) {
        return <CircularProgress/>
    }

    if (error) {
        return <ErrorMessage error={error}/>
    }

    if (page.content.length === 0) {
        return <Box sx={{mt: 2}}>All done!</Box>
    }

    const testRun = page.content[0]

    return (
        <Box sx={{marginBottom: "420px", mt: 2}}>
            <TestRunCard
                key={testRun.row.id}
                qualityCheckJson={model.qualityCheck}
                template={model.template}
                testRun={testRun}
                didUpdate={(updated) => {
                    loadPage()
                    reloadQualityCheckStats()
                }}
                didDelete={() => loadPage()}
            />
        </Box>
    )
}

export default TestRunScoringPanel;